import { render } from "./Symboliek.vue?vue&type=template&id=8390c74e&scoped=true"
import script from "./Symboliek.vue?vue&type=script&lang=js"
export * from "./Symboliek.vue?vue&type=script&lang=js"

import "./Symboliek.vue?vue&type=style&index=0&id=8390c74e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8390c74e"]])

export default __exports__